import { useCallback, useEffect, useRef, useState } from "react";
import {
  fetchAdminDashboardStats,
  fetchAdminDashboardAlerts,
} from "./adminDashboardApi";

const POLL_INTERVAL_MS = 30_000;

export function useAdminDashboard() {
  const [stats, setStats] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const pollRef = useRef(null);

  const load = useCallback(async ({ silent } = {}) => {
    if (!silent) setLoading(true);
    setError(null);
    try {
      const [statsData, alertsData] = await Promise.all([
        fetchAdminDashboardStats(),
        fetchAdminDashboardAlerts(),
      ]);
      setStats(statsData);
      setAlerts(alertsData);
    } catch (err) {
      setError(err);
    } finally {
      if (!silent) setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    pollRef.current = setInterval(() => load({ silent: true }), POLL_INTERVAL_MS);
    return () => clearInterval(pollRef.current);
  }, [load]);

  return {
    stats,
    alerts,
    loading,
    error,
    refresh: () => load(),
  };
}